import { Avatar, Box, Paper, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { MemoryMessage } from "../hooks/useMemoryMessages";
import { ContactDetailModal } from "./ContactDetailModal";

interface RecentCommentsSidebarProps {
  messages: MemoryMessage[];
}

export function RecentCommentsSidebar({
  messages,
}: RecentCommentsSidebarProps) {
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);

  const recentComments = useMemo(() => {
    return [...messages]
      .sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      )
      .slice(0, 5);
  }, [messages]);

  return (
    <>
      <Paper sx={{ borderRadius: 3, p: 2, boxShadow: 0 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: "14px", color: "#1e293b", mb: 2 }}
        >
          Recent Comments
        </Typography>
        <Stack spacing={1.5}>
          {recentComments.map((c) => (
            <Stack
              key={c.id}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    bgcolor: "action.hover",
                    color: "text.secondary",
                    fontSize: "12px",
                  }}
                >
                  {(c.sender_full_name ?? "A").charAt(0)}
                </Avatar>
                <Box>
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}
                  >
                    {c.sender_full_name ?? "Anonymous"}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                    {c.comment_source === "generic"
                      ? "Memorial Page"
                      : "Youtube"}
                  </Typography>
                </Box>
              </Stack>
              <Typography
                onClick={() => setSelectedEmail(c.sender_email ?? "")}
                sx={{
                  fontSize: "12px",
                  color: "#724e41",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                View
              </Typography>
            </Stack>
          ))}
          {recentComments.length === 0 && (
            <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
              No recent comments
            </Typography>
          )}
        </Stack>
      </Paper>
      {selectedEmail && (
        <ContactDetailModal
          open={!!selectedEmail}
          onClose={() => setSelectedEmail(null)}
          senderEmail={selectedEmail}
          messages={messages}
        />
      )}
    </>
  );
}
